import SiteButton_WrappingButtonComponent from '../components/SiteButton/viewer/skinComps/BaseButton/WrappingButton.skin';
import SiteButton_WrappingButtonController from '../components/SiteButton/viewer/SiteButton.controller';


const SiteButton_WrappingButton = {
  component: SiteButton_WrappingButtonComponent,
  controller: SiteButton_WrappingButtonController
};


export const components = {
  ['SiteButton_WrappingButton']: SiteButton_WrappingButton
};

